import { ShieldCheck, Leaf, UtensilsCrossed } from "lucide-react";

const items = [
  {
    icon: ShieldCheck,
    title: "Healthy",
    description:
      "Enhance your well-being with our product, which is designed to provide essential nutrients and support a balanced diet for a healthier lifestyle.",
  },
  {
    icon: Leaf,
    title: "Reduce carbon footprint",
    description:
      "Contribute to environmental sustainability with our product, crafted through eco-friendly methods that minimize carbon emissions and promote long-term durability.",
  },
  {
    icon: UtensilsCrossed,
    title: "Nutritious",
    description:
      "Enjoy the benefits of a nutrient-rich product that is packed with vitamins, minerals, and other essential components to support your overall health and vitality.",
  },
];

function Highlights() {
  return (
    <section id="highlights" className="bg-forest text-canvas py-16 sm:py-24">
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        <div className="max-w-xl mb-12 sm:mb-16">
          <h2 className="font-display text-3xl sm:text-4xl mb-3">Highlights</h2>
          <p className="text-canvas/70">
            Experience Fighn Flour: instant nutrition, eco-friendly, and fortified.
            Enjoy convenience, health, and sustainability.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6">
          {items.map(({ icon: Icon, title, description }) => (
            <div
              key={title}
              className="border border-canvas/15 rounded-2xl p-7 bg-canvas/[0.03]"
            >
              <Icon className="w-6 h-6 text-grain mb-4" />
              <h3 className="font-medium text-lg mb-2">{title}</h3>
              <p className="text-canvas/65 text-sm leading-relaxed">{description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Highlights;